import { useState } from "react";
import { Button, Popconfirm, Table } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import UploadBricksModal from "./UploadBricksModal";
import useOrganization from "../../hooks/useOrganization";
import { updateBrickCollection } from "../../utils";

interface Props {
  brickCollection: any | null;
  onChange(): void;
}

const BricksList: React.FC<Props> = ({ brickCollection, onChange }) => {
  const organization = useOrganization();
  const [showUpload, setShowUpload] = useState(false);
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const deleteBrick = async (brickId: string) => {
    setDeletingId(brickId);
    try {
      await updateBrickCollection(organization, brickCollection._id, {
        bricks: brickCollection.bricks.filter((b: any) => b._id !== brickId),
      });
      onChange();
    } finally {
      setDeletingId(null);
    }
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (image: string) => <img style={{ width: 75 }} src={image} />,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "",
      key: "actions",
      width: 64,
      render: (_: unknown, brick: any) => (
        <Popconfirm
          title="Delete this brick image?"
          okText="Delete"
          okButtonProps={{ danger: true }}
          onConfirm={() => deleteBrick(brick._id)}
        >
          <Button
            danger
            icon={<DeleteOutlined />}
            loading={deletingId === brick._id}
            aria-label="Delete brick image"
          />
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setShowUpload(true)}
        />
      </div>
      <Table
        rowKey="_id"
        loading={brickCollection?.bricks == null}
        columns={columns}
        dataSource={brickCollection?.bricks}
      />
      <UploadBricksModal
        brickCollection={brickCollection}
        open={showUpload}
        onClose={() => {
          setShowUpload(false);
          onChange();
        }}
      />
    </>
  );
};

export default BricksList;
